import React from 'react';
import { Helmet } from 'react-helmet-async';
import SportsTeamHero from '../components/SportsTeamHero';
import SportsTeamNameGenerator from '../components/SportsTeamNameGenerator';
import SportsTeamFeatures from '../components/SportsTeamFeatures';
import SportsTeamHowItWorks from '../components/SportsTeamHowItWorks';
import SportsTeamTestimonials from '../components/SportsTeamTestimonials';
import SportsTeamGuide from '../components/SportsTeamGuide';
import SportsTeamSEOContent from '../components/SportsTeamSEOContent';
import SportsTeamFAQ from '../components/SportsTeamFAQ';
import SportsTeamCallToAction from '../components/SportsTeamCallToAction';

export default function SportsTeamPage() {
  return (
    <>
      <Helmet>
        <title>Sports Team Name Generator | Create Perfect Team Names Instantly</title>
      </Helmet>
      <SportsTeamHero />
      <SportsTeamNameGenerator />
      <SportsTeamFeatures />
      <SportsTeamHowItWorks />
      <SportsTeamTestimonials />
      <SportsTeamGuide />
      <SportsTeamSEOContent />
      <SportsTeamFAQ />
      <SportsTeamCallToAction />
    </>
  );
}